/* klucze muszą mieć numeryczne wartości w celu szybszych wyszukiwań */

const vehicle_states = [
  { key: 1, value: 1, text: "używane" },
  { key: 2, value: 2, text: "nowe" }
];

export default vehicle_states;